import { Injectable } from '@angular/core';

@Injectable({
    // Ensures it's a singleton
    providedIn: 'root' 
})
export class SharedDataService {
    // Determines whether or not the code is running on smartphone app
    public isApp: boolean;
    // Use debug = false on prod
    public isDebug: boolean = false;
}